// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgv_a bib_vt bib_ea bib_a","MenuItem__Btn":"bgv_b bib_z","MenuItem__subtitle":"bgv_c"};